// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shopping-foot .el-image-viewer__wrapper{z-index:2010!important}.shopping-foot .el-icon-circle-close:before{color:#fff}", ""]);
// Exports
module.exports = exports;
